import { CareTypeCard } from './CareTypeCard';
import { CARE_TYPE_CARDS } from '../constants/careCosts.constants';

export const CareTypeCards = () => (
  <section>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {CARE_TYPE_CARDS.map((card, index) => (
        <CareTypeCard
          key={card.title}
          icon={card.icon}
          title={card.title}
          body={card.body}
          className={index === 4 ? 'md:col-span-2 mx-auto w-full max-w-sm' : undefined}
        />
      ))}
    </div>
  </section>
);
